import references from "./references";

export const REFERENCES_NAMESPACE = "references";

export default references;
